<div class="main-container">
  <app-navbar></app-navbar>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
  <app-scroll-to-top></app-scroll-to-top>
</div>
